import { get, isEmpty } from '@/utils/helpers';
import { CLEAR_PAGE } from '../base/types';
import { CREATE_CONSULTATION } from '../consultations/consultationsActionsTypes';
import { FETCH_USER, ADD_GIFT_CONSULTATION_USER, ADD_GIFT_NUTRITION_CONSULTATION_USER, UPDATE_USER, DELETE_CONSULTATION_USER, DELETE_NUTRITION_CONSULTATION_USER } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: {},
};

const userReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_USER}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_USER}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_USER}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case `${ADD_GIFT_CONSULTATION_USER}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {
          ...state.data,
          consultations: [payload, ...(state?.data?.consultations || [])],
        },
      };
    case `${ADD_GIFT_NUTRITION_CONSULTATION_USER}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {
          ...state.data,
          nutrition_consultations: [payload, ...(state?.data?.nutrition_consultations || [])],
        },
      };
    case `${CREATE_CONSULTATION}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {
          ...state.data,
          consultations: get(state, ['data', 'consultations'], []).map((i) => {
            if (Number(i.id) === Number(payload.id)) {
              return payload;
            }
            return i;
          }),
        },
      };

    case `${UPDATE_USER}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoading: false,
      };

    case `${DELETE_CONSULTATION_USER}_FULFILLED`:
    case `${DELETE_NUTRITION_CONSULTATION_USER}_FULFILLED`: {
      if (isEmpty(payload) || !payload?.id) return state;
      const key = type === `${DELETE_NUTRITION_CONSULTATION_USER}_FULFILLED` ? 'nutrition_consultations' : 'consultations';
      return {
        ...state,
        data: {
          ...(state?.data || {}),
          [key]: state?.data?.[key]?.filter((i) => Number(i.id) !== Number(payload.id)),
        }
      };
    }

    case CLEAR_PAGE:
      return payload === 'user' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default userReducer;
